<template>
  <div class="bg_bg">
    <title-bar-back :title="'日期选择'" @back="back">
      <div class="title_right"></div>
    </title-bar-back>
    <div class="top_col">
      <top-det />
    </div>
    <choose-dates @chooseDate="chooseDate" />
    <div class="submit_btn colof87 font12 line_height_17" @click="goBack">
      提交
    </div>
  </div>
</template>

<script>
// import dayjs from "dayjs";
const TitleBarBack = () =>
  import("@/components/TitleBarBack").then(m => m.default || m);
import TopDet from "./components/TopDet";
import ChooseDates from "./components/ChooseDates";
export default {
  name: "ChooseDate",
  components: {
    TitleBarBack,
    TopDet,
    ChooseDates
  },
  data() {
    return {};
  },
  mounted() {
    this.chooseCurDate = this.propsDate;
  },
  methods: {
    back() {
      this.$router.back();
    },
    goBack() {
      this.$router.go(-1);
    },
    chooseDate(date) {
      if (this.$route.query.purPage === "pur") {
        localStorage.setItem("mall-wap-pur-choosedate", date);
      } else if (this.$route.query.purPage === "exchangeCard") {
        localStorage.setItem("mall-wap-exchange-card-choosedate", date);
      } else {
        localStorage.setItem("mall-wap-milkplan-choosedate", date);
      }
    }
  }
};
</script>

<style lang="less" scoped>
.bg_bg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #fff;
  .top_col {
    background: #f6f7f8;
    padding: 12px 10px;
  }
}
.title_right {
  width: 36px;
}

.submit_btn {
  background: linear-gradient(180deg, #e8caa1 0%, #bf9264 100%);
  box-shadow: -1px -1px 4px 0px rgba(255, 255, 255, 0.5);
  border-radius: 18px;
  margin: 0 24px;
  padding: 10px 0;
  position: absolute;
  bottom: 12px;
  left: 0;
  right: 0;
}
</style>
